<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  methods: {
    changeLanguage(locale) {
      this.$store.commit('setLocale', locale);
    }
  }
}
</script>
